/* eslint-disable */
const getters = {
  getQuestion(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
